<template>
  <div class="content">
    <div class="row">
      <div class="col-md-4">
        <fg-input
          v-model="remote_sim_info.sim_server_name"
          type="text"
          :label="translate('sim_server.simserver_name')"
          :placeholder="translate('sim_server.simserver_name')"
          :readonly="true"
        />
      </div>
      <div class="col-md-4">
        <fg-input
          v-model="remote_sim_info.sim_reader_name"
          type="text"
          :label="translate('sim_server.simreader_name')"
          :placeholder="translate('sim_server.simreader_name')"
          :readonly="true"
        />
      </div>
      <div class="col-md-4">
        <fg-input
          v-model="remote_sim_info.sim_reader_slot"
          type="text"
          :label="translate('sim_server.sim_reader_slot')"
          :placeholder="translate('sim_server.sim_reader_slot')"
          :readonly="true"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <fg-input
          v-model="remote_sim_info.mno"
          type="text"
          :label="translate('sim_server.mno')"
          :placeholder="translate('sim_server.mno')"
          :readonly="true"
        />
      </div>

     <div class="col-md-4">
        <fg-input
          v-model="remote_sim_info.imsi"
          type="text"
          :label="translate('sim_server.imsi')"
          :placeholder="translate('sim_server.imsi')"
          :readonly="true"
        />
      </div>
      <div class="col-md-4">
        <fg-input
          v-model="remote_sim_info.iccid"
          type="text"
          :label="translate('sim_server.iccid')"
          :placeholder="translate('sim_server.iccid')"
          :readonly="true"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <fg-input
          v-model="remote_sim_info.status"
          type="text"
          :label="translate('sim_server.status')"
          :placeholder="translate('sim_server.status')"
          :readonly="true"
        />
      </div>
      <div class="col-md-4">
        <fg-input
          v-model="remote_sim_info.simcard_status"
          type="text"
          :label="translate('sim_server.sim_status')"
          :placeholder="translate('sim_server.sim_status')"
          :readonly="true"
        />
      </div>
      <div class="col-md-4" v-if="remote_sim_info.simcard_status === 'Error'">
        <button
                class="btn btn-danger btn-fill btn-wd marginButton"
                @click.prevent="reset"
            >
                Reset
            </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6" >
        <fg-input
          v-model="ts_create"
          type="text"
          :label="translate('sim_server.ts_create')"
          :placeholder="translate('sim_server.ts_create')"
          :readonly="true"
        />
      </div>
      <div class="col-md-6" >
        <fg-input
          v-model="ts_update"
          type="text"
          :label="translate('sim_server.ts_update')"
          :placeholder="translate('sim_server.ts_update')"
          :readonly="true"
        />
      </div>
    </div>


    <div class="row" v-if="remote_sim_info.device !== null">
      <div class="col-md-6">
        <fg-input
            v-model="device"
            type="text"
            :label="translate('sim_server.current_device_name')"
            :placeholder="translate('sim_server.current_device_name')"
            :readonly="true"
        />
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <button
              class="btn btn-danger btn-fill btn-wd marginButton"
              @click.prevent="unload"
          >
            {{ translate('btn.unload') }}
          </button>
        </div>
      </div>
    </div>


    <div class="row" v-if="remote_sim_info.binding !== null">
        <div class="col-md-6" >
          <fg-input
              v-model="bindingText"
              type="text"
              :placeholder="translate('sim_server.binding')"
              :readonly="true"
          />
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <button
                class="btn btn-danger btn-fill btn-wd marginButton"
                @click.prevent="unbind"
            >
              {{ translate('btn.unbind') }}
            </button>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-md-4" >
          <fg-input
              v-model="bindingFid"
              type="text"
              :placeholder="translate('sim_server.device_fid')"
          />
        </div>
        <div class="col-md-4" >
          <fg-input
              v-model="bindingSlot"
              type="text"
              :placeholder="translate('sim_server.device_slot')"
          />
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <button
                class="btn btn-success btn-fill btn-wd marginButton"
                @click.prevent="bind"
            >
              {{ translate('btn.bind') }}
            </button>
          </div>
        </div>
      </div>

  </div>

</template>
<script>


export default {
    name: "RemoteSimInfo",
    props: ['remote_sim_info'],
    data () {
        return {
            options_day: {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            },
            options_daytime: {
              hour12: false,
              hour: '2-digit',
              minute: '2-digit',
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            },
            bindingFid :'',
            bindingSlot: '',
        }
    },
    computed:{
      ts_create(){
        return this.remote_sim_info.ts_create > 0 ? this.get_date(this.remote_sim_info.ts_create, this.options_day ) : ''
      },
      ts_update(){
        return this.remote_sim_info.ts_update > 0 ? this.get_date(this.remote_sim_info.ts_update, this.options_daytime) : ''
      },
      device(){
        if (!this.remote_sim_info.device) return
        return this.remote_sim_info.device?.name + ' (' + this.remote_sim_info.device?.fid + ')'
      },
      bindingText(){
        return this.remote_sim_info.binding.fid + "(" + this.remote_sim_info.binding.name + ") slot = " + this.remote_sim_info.binding.slot;
      }

    },
    methods: {
      cancel () {
          this.$emit('close')
       },
        bind () {
          let bind_simcard_data = {
                sim_reader_simcard_id: this.remote_sim_info.id,
                fid: this.bindingFid,
                slot: this.bindingSlot,
            }
          this.$http.simcard.bindSimcard( bind_simcard_data, (response) => {
            this.global_notify('info', this.translate('sim_server.simcard_binded_success') )
            this.$emit('close')
            this.$emit('update')
          })
        },

        unbind () {
          this.$http.simcard.unbindSimcard( this.remote_sim_info.id, (response) => {
            this.global_notify('info', this.translate('sim_server.simcard_unbinded_success') )
            this.$emit('close')
            this.$emit('update')
          })
        },

        unload () {
          this.$http.simcard.unloadSimcard( this.remote_sim_info.id, (response) => {
            this.global_notify('info', this.translate('sim_server.simcard_unload') )
            this.$emit('close')
            this.$emit('update')
          })
        },

        reset() {
          this.$http.simcard.resetSimcardStatus( this.remote_sim_info.id, (response) => {
            this.global_notify('info', this.translate('sim_server.simcard_reset') )
            this.$emit('close')
            this.$emit('update')
          })
        }
    }
}
</script>
<style lang="scss" scoped>
  .content{
    .row{
      margin: 0;
      text-align: left;
      display: flex;
      align-items: flex-end;
      .area{
        margin-bottom: 10px;
      }
      .form-group{
        margin-bottom: 10px;
        button{
          width: 100%;
          height: 40px;
          margin: 0;
        }
      }
    }
  }
</style>
